<div class="row">
  <div class="col-12">
    <div class="row">
      <div class="col-xs-12 col-sm-auto">
        <div class="page-title-box">
          <h4 class="page-title">{{ title }}</h4>
        </div>
      </div>
      @if (hasBreadcrumb) {
        <div class="col-xs-12 col-sm-auto align-items-end d-flex ms-auto">
          <ol class="breadcrumb m-0">
            @for (item of breadcrumb; track item.label) {
              @if (!item.href) {
                <li class="breadcrumb-item active">
                  {{ item.label | translate }}
                </li>
              } @else {
                <li class="breadcrumb-item">
                  <a [routerLink]="[item.href]">{{ item.label | translate }}</a>
                </li>
              }
            }
          </ol>
        </div>
      }
    </div>
  </div>
</div>
